import { API_CONFIG } from "../config/api";

const API_BASE_URL = API_CONFIG.BASE_URL;

export class MigrationService {
  static async getAuthHeaders(getAccessTokenSilently) {
    const token = await getAccessTokenSilently();
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }

  // Get controls that need migration to sub-categories
  static async getControlsNeedingMigration(
    organizationId,
    getAccessTokenSilently
  ) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/migration/control-categories/${organizationId}`,
      { headers }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Failed to fetch controls needing migration"
      );
    }

    return response.json();
  }

  // Perform bulk migration of controls to sub-categories
  static async migrateControlCategories(data, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/migration/migrate-control-categories`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Failed to migrate control categories"
      );
    }

    return response.json();
  }

  // Get migration status for an organization
  static async getMigrationStatus(organizationId, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/migration/status/${organizationId}`,
      { headers }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch migration status");
    }

    return response.json();
  }
}
